// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleListDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {

  var m = require('mobx');
  var trackable = require('share/tracking/Izenda.Trackable');

  var RoleListDetail = function (data) {
    var props = {
      id: null,
      name: null,
      active: null,
      tenantID: null,
      detailInfo: null,
      deleted: false,
      isSelected: false
    };

    m.extendObservable(trackable(this), props);
    data && this.readBasicInfo(data);
  };

  RoleListDetail.prototype.readBasicInfo = m.action(function (data) {
    this.id = data.id;
    this.name = data.name;
    this.active = data.active;
    this.deleted = data.deleted;
    this.tenantID = data.tenantID;
  });

  /**
   * unselect role
   */
  RoleListDetail.prototype.unselectRole = m.action(function () {
    this.isSelected = false;
  });

  /**
   * select role
   */
  RoleListDetail.prototype.selectRole = m.action(function () {
    this.isSelected = true;
  });

  /**
   * delete current role
   */
  RoleListDetail.prototype.delete = m.action(function () {
    this.deleted = true;
  });

  /**
   * toggle active status
   */
  RoleListDetail.prototype.toggleActive = m.action(function () {
    this.active = !this.active;
  });



  module.exports = RoleListDetail;
}());



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.RoleListDetail.js